<template>
    <div>
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div class="admin-page-content user-crud">
            <form @submit.prevent="handleSubmit" method="post"
                class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="userform">
                <claim-tab ref="claimTab" @send-claim-data-to-parent="handleClaimTabData" :viewAllfields="disableFields"
                    :dealerFieldsDisabled="dealerFieldsDisabled" :disableAllFields="disableAllFields"
                    :disableClaimHeader="disableClaimHeader"
                    @send-claim-number-to-parent="handleClaimNumber" @send-vin-to-parent="handleVIN"
                    @send-repair-date="handleRepairDate" @send-rma-to-parent="handleRma"
                    @send-cm-issued-to-parent="handleCMIssued" @send-claim-status-to-parent='handleClaimStatus'
                    @send-labor-travel-rate-to-parent="handleLaborTravelRate"></claim-tab>
                <hr style="border: none; border-top: 2px solid #002B6C;">
                <failure-tab ref="failureTab" @send-failure-data-to-parent="handleFailureTabData"
                    :dealerFieldsDisabled="dealerFieldsDisabled" @send-position-code-to-parent="handlePositionCodeData"
                    :viewAllfields="disableFields" :disableAllFields="disableAllFields"
                    :showCorrectionMadeButton="showCorrectionMadeButton"></failure-tab>
                <hr style="border: none; border-top: 2px solid #002B6C;">
                <labor-tab ref="laborTab" @send-labor-data-to-parent="handleLaborTabData" :viewAllfields="disableFields"
                    @send-calculation-labor-data-to-parent="handleLaborCalculationData"
                    :dealerFieldsDisabled="dealerFieldsDisabled" :disableAllFields="disableAllFields"
                    :claimStatus="claimStatus"></labor-tab>
                <hr style="border: none; border-top: 2px solid #002B6C;">
                <part-tab ref="partTab" @send-part-data-to-parent="handlePartTabData"
                    @send-part-attachment-data-to-parent="handlePartAttachment"
                    @send-part-number-to-parent="handlePartNumberData" :viewAllfields="disableFields"
                    :dealerFieldsDisabled="dealerFieldsDisabled" :disableAllFields="disableAllFields"
                    @send-calculation-part-data-to-parent="handlePartCalculationData"
                    :claimStatus="claimStatus"></part-tab>
                <hr style="border: none; border-top: 2px solid #002B6C;">
                <other-charge-tab ref="otherChargeTab" @send-other-charges-data-to-parent="handleOtherChargesTabData"
                    :viewAllfields="disableFields" :dealerFieldsDisabled="dealerFieldsDisabled"
                    :disableAllFields="disableAllFields"
                    @send-calculation-other-charges-data-to-parent="handleOtherChargesCalculationData"
                    :claimStatus="claimStatus"></other-charge-tab>
                <hr style="border: none; border-top: 2px solid #002B6C;">
                <attachment-tab ref="attachmentTab" @send-attachment-data-to-parent="handleAttachmentTabData"
                    :viewAllfields="disableFields" :dealerFieldsDisabled="dealerFieldsDisabled"
                    :disableAllFields="disableAllFields"
                    :claimStatus="claimStatus"
                    :canViewAllFields="canViewAllFields"></attachment-tab>
                <hr style="border: none; border-top: 2px solid #002B6C;">
                <summary-tab ref="summaryTab" @send-review-data-to-parent="handlesummaryTabData"
                    :viewAllfields="disableFields" :disableAllFields="disableAllFields"
                    :loadAllDealers="loadAllDealers"></summary-tab>
                <hr style="border: none; border-top: 2px solid #002B6C;">
            </form>
        </div>
        <div v-if="showButtons" class="button-container">
            <template>
                <!-- Save & Continue Dealer -->
                <button v-if="!isEditPage && !disableSaveButtons" type="submit" class="btn btn-secondary"
                    v-on:click="getSectionData('Save and Continue')">
                    Save & Continue
                </button>

                <!-- Save & Close Dealer -->
                <button v-if="(!isEditPage && !disableSaveButtons) && !canViewAllFields" type="submit" class="btn btn-secondary"
                    v-on:click="getSectionData()">
                    Save & Close
                </button>

                <!-- Update & Continue -->
                <button v-if="(isEditPage && !disableSaveButtons && !disableAllFields) || (loadAllDealers && !disableUpdateButtons)" type="submit" class="btn btn-secondary"
                    v-on:click="getSectionData('Update and Continue')">
                    Update & Continue
                </button>

                <!-- Update & Close -->
                <button v-if="(statusOpenBtnEnable && !canViewAllFields) || ((isEditPage && !disableSaveButtons && !disableAllFields) || (loadAllDealers && !disableUpdateButtons))"
                    type="submit" class="btn btn-secondary"
                    @click="getSectionData()">
                    Update & Close
                </button>

                <!-- Save & Close Rizon Admin-->
                <!-- not needed for admin
                <button v-if="(canViewAllFields && !disableAllFields)" type="submit" class="btn btn-secondary"
                    @click="getSectionData('rizon-save-and-close')">
                    Save & Close
                </button> -->

                <!-- Accept -->
                <button v-if="
                    (!['Accepted', 'Returned for Corrections'].includes(claimStatus)) && canViewAllFields"
                    type="submit" class="btn btn-secondary" @click="acceptWarrantyClaim()">
                    Accept
                </button>

                <!-- Deny -->
                <button v-if="!['Rejection/Denied', 'Returned for Corrections'].includes(claimStatus)
                    && canViewAllFields" type="submit" class="btn btn-secondary"
                    @click="deleteClaimModal('Rejection/Denied')">
                    Deny
                </button>

                <!-- Return For Corrections -->
                <button v-if="
                    (
                        claimStatus != 'Returned for Corrections'
                        &&
                        canViewAllFields
                    )
                    || (claimStatus == 'Open' && canViewAllFields)" type="submit" class="btn btn-secondary"
                    @click="deleteClaimModal('Returned for Corrections')">
                    Return For Corrections
                </button>

                <!-- Create RMA -->
              <button
                v-if="claimStatus !== 'Waiting on Parts' && claimStatus !== 'Returned for Corrections' && canViewAllFields && isEditPage"
                type="submit" class="btn btn-secondary"
                @click="createRMAButton()">
                Create RMA
              </button>

                <!-- Submit For Payment -->
              <button
                v-if="claimStatus !== 'Payment Pending' && claimStatus !== 'Returned for Corrections'  && canViewAllFields && isEditPage"
                type="submit" class="btn btn-secondary"
                @click="submitForPaymentButton()">
                Submit For Payment
              </button>

                <!-- commented because of no use
                <button type="submit" class="btn btn-secondary" v-if="canViewAllFields">
                    Falcon
                </button>
                <button type="submit" class="btn btn-secondary" v-if="canViewAllFields">
                    Paid
                </button> -->

                <!-- Cancel -->
                <button v-if="(canViewAllFields || showCorrectionMadeButton) && isEditPage" type="submit" class="btn btn-secondary"
                    @click="showSwalPopup('cancel')">
                    Cancel
                </button>

                <!-- Credit Memo Issued -->
                <button v-if="
                    !hideCreditMemoButton
                    &&
                    claimStatus == 'Accepted'
                    &&
                    canViewAllFields
                    &&
                    isEditPage" type="submit" class="btn btn-secondary" @click="creditMemoIssuedButton()">
                    Create Credit Memo
                </button>

                <!-- Clear Content -->
                <button v-if="!isEditPage && !disableAllFields" type="submit" class="btn btn-secondary"
                    @click="showSwalPopup('clear')">
                    Clear Content
                </button>

                <!-- Delete -->
                <button v-if="isEditPage && claimStatus != '' && (claimStatus == 'Draft' || claimStatus == 'Open') && !disableAllFields"
                    type="submit" class="btn btn-secondary" @click="deleteClaimModal('Deleted')">
                    Delete
                </button>

                <!-- Print to PDF -->
                <button type="submit" v-if="isEditPage" class="btn btn-secondary" v-on:click="generatePDF()">
                    Print to PDF
                </button>

                <!-- Submit -->
                <button v-if="claimStatus == '' || claimStatus == 'Draft'" type="submit" class="btn btn-secondary"
                    @click="submitWarrantyClaim()">
                    Submit
                </button>

                <!-- Corrections Made -->
                <button v-if="claimStatus != 'Corrections Made/Dealer Response' && showCorrectionMadeButton" type="submit" class="btn btn-secondary"
                    @click="correctionsMadeForWarrantyClaim()">
                    Corrections Made
                </button>
            </template>
        </div>

        <!-- Modal for adding comment while deleting -->
        <div class="modal fade policy-modal" id="addDeleteCommentModal" ref="addDeleteCommentModal"
            data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ commentModalHeader }}</h5>
                    </div>
                    <div class="modal-body">
                        <textarea class="form-control" v-model.trim="deleteComment" rows="3" maxlength="3000"
                            placeholder="Write reason here..."></textarea>
                        <div class="col-md-12 mt-0 pr-0 text-right">
                            <span>{{ deleteCommentCharsCount }}/3000</span>
                        </div>
                        <span v-if="deleteCommentErrorMsg" class="field-error">{{ deleteCommentErrorMsg }}</span>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary" type="button" v-on:click="addDeleteComment()">Submit</button>
                        <button class="btn btn-tertiary" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import moment from 'moment';
import 'moment-timezone';

import { commonMixins } from '../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
import { contractMixins } from "../mixins/contractMixins";
import EvClaimTabVue from "@/components/warrantyClaimTabs/EvClaimTab.vue";
import EvFailureTabVue from "@/components/warrantyClaimTabs/EvFailureTab.vue";
import EvLocationTabVue from "@/components/warrantyClaimTabs/EvLocationTab.vue";
import EvPartTab from "./warrantyClaimTabs/EvPartTab.vue";
import EvLaborTab from "./warrantyClaimTabs/EvLaborsTab.vue";
import EvOtherChargeTab from "./warrantyClaimTabs/EvOtherChargeTab";
import EvPaymentTab from "./warrantyClaimTabs/EvPaymentTab.vue";
import EvAttachmentTab from "./warrantyClaimTabs/EvAttachmentTab.vue";
import EvWarrantyClaimReview from "./warrantyClaimTabs/EvWarrantyClaimReview.vue";
import EvSummaryTab from "./warrantyClaimTabs/EvSummaryTab.vue";

Vue.component("loading-content", LoadingContent);
Vue.component("claim-tab", EvClaimTabVue);
Vue.component("failure-tab", EvFailureTabVue);
Vue.component("location-tab", EvLocationTabVue);
Vue.component("part-tab", EvPartTab);
Vue.component("labor-tab", EvLaborTab);
Vue.component("other-charge-tab", EvOtherChargeTab);
Vue.component("payment-tab", EvPaymentTab);
Vue.component("attachment-tab", EvAttachmentTab);
Vue.component("review-tab", EvWarrantyClaimReview);
Vue.component("summary-tab", EvSummaryTab);

export default {
    name: "WarrantyClaimFormCreate",
    components: {
        appFooter: () => import('@/components/Footer')
    },
    mixins: [commonMixins, contractMixins],
    data: () => ({
        permissions: [],
        role: '',
        claimTabData: null,
        failureTabData: null,
        partTabData: null,
        laborTabData: null,
        otherChargesTabData: null,
        locationTabData: null,
        paymentTabData: null,
        attachmentTabData: null,
        summaryTabData: null,
        sendingTabData: null,
        sendingLineItemData: null,
        claimId: null,
        loading: false,
        loadAllDealers: false,
        canViewAllFields: false,
        disableFields: false,
        warrantyClaimData: {},
        partAttachment: null,
        isEditPage: false,
        claimStatus: '',
        claimHeaderId: 0,
        deleteComment: '',
        deleteCommentCharsCount: 0,
        deleteCommentErrorMsg: '',
        userObj: JSON.parse(localStorage.getItem("user_obj")),
        claimCreateFlag: '',
        showButtons: true,
        setClaimStatus: '',
        disableSaveButtons: false,
        showCorrectionMadeButton: false,
        commentModalHeader: '',
        rmaRequired: false,
        cmIssued: false,
        cancelPopUpMsg: 'Are you sure you want to cancel all unsaved changes?',
        backPopUpMsg: 'Are you sure you want to discard all unsaved changes and return to the list page?',
        clearContentPopUpMsg: 'Are you sure you want to clear this warranty claim?',
        rma: '',
        creditMemoDate: '',
        creditMemoNumber: '',
        rePopulate: false,
        changedClaimStatus: '',
        useSubmitMessage: false,
        dealerFieldsDisabled: true,
        additionalComment: null,
        disableAllFields: false,
        disableClaimHeader: false,
        disableUpdateButtons: false,
        formFieldChanged: false,
        hideCreditMemoButton: false,
        statusOpenBtnEnable: false
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (const element of permissions) {
                    if (element.name == 'ev_load_all_dealer_dropdown') {
                        self.loadAllDealers = true;
                    }
                    if (element.name == 'ev_view_all_form_fields') {
                        self.canViewAllFields = true;
                        self.claimStatusChanged(self.claimStatus);
                        self.disableFields = true;
                        if (!this.isEditPage) {
                            this.checkClaimStatus();
                        }
                    }
                    if (element.name == 'ev_claim_dealer_only_fields') {
                        self.dealerFieldsDisabled = false;
                    }
                }
            }
            this.$refs.claimTab.getDealerLoadData(self.loadAllDealers);
        },
        claimStatus(status) {
            this.claimStatusChanged(status);
        },
        //if state value update after then change the city value also update that in thie module.
        state: function (state) {

            var self = this;

            if (self.state == null) {
                self.city = null;
                self.cityArr = [];
            }
        },
        deleteComment: function (newValue) {
            if (newValue.length > 3000) {
                this.deleteComment = newValue.substring(0, 3000);
            }
            this.deleteCommentCharsCount = newValue.length;
        }
    },
    mounted: function () {
        if (this.$route.params.id > 0) {
            this.isEditPage = true;
            this.claimId = this.$route.params.id;
            this.loadClaimData();
        }
        this.getPermissions();

    },

    methods: {
        claimStatusChanged(status){
            if (
                (
                    status == "Open"
                    ||
                    status == "Accepted"
                    ||
                    status == "Rejection/Denied"
                    ||
                    status == 'Corrections Made/Dealer Response'
                    ||
                    status == 'Waiting on Parts'
                    ||
                    status == 'Payment Pending'
                    ||
                    status == 'CM Issued'
                    ||
                    status == 'Returned for Corrections'
                    ||
                    status == 'In Process'
                )
                &&
                !this.canViewAllFields
            )
            {
                // Disabled all the fields and buttons for dealers
                this.disableSaveButtons = true;
                this.disableAllFields = true;
                if (status == 'Returned for Corrections'){
                    this.showCorrectionMadeButton = true;
                    this.disableAllFields = false;
                    this.disableClaimHeader = true;
                } else if(status == 'Open') {
                    this.statusOpenBtnEnable = true;
                }
            } else if (status == "Deleted") {
                this.disableAllFields = true;
                this.showButtons = false;
                this.$parent.handleButtonClick();
            } else if (status == "In Process" && !this.canViewAllFields) {
                this.disableSaveButtons = true;
            } else if (
                (
                    status == "Draft"
                    ||
                    status == "Open"
                    ||
                    status == "Returned for Corrections"
                    ||
                    status == "Corrections Made/Dealer Response"
                    ||
                    status == "In Process"
                    ||
                    status == "Rejection/Denied"
                )
                && this.canViewAllFields
            ) {
                if( status == 'In Process' ) {
                    this.disableAllFields = false;
                    this.disableUpdateButtons = false;
                    this.disableClaimHeader = true;
                } else {
                    this.disableAllFields = true;
                    this.disableUpdateButtons = true;
                }
            }
        },
        handleSubmit(event) {
            // This method is called when form is submitted
            // We will do nothing, because the form is submitted through the buttons
        },
        handleClaimNumber(claimNumberData) {
            this.emitClaimNumbertoParent(claimNumberData);
        },
        handleVIN(vinData) {
            this.emitVINToParent(vinData);
        },
        handleClaimTabData(dataFromClaimTab) {
            var self = this;
            self.claimTabData = dataFromClaimTab;
            this.$refs.failureTab.emitDataToParent();
        },
        handleFailureTabData(dataFromFailureTab) {
            var self = this;
            self.failureTabData = dataFromFailureTab;
            this.$refs.laborTab.emitDataToParent();
        },
        handleLaborTabData(dataFromLaborTab) {
            var self = this;
            self.laborTabData = dataFromLaborTab;
            this.$refs.partTab.emitDataToParent();
        },
        handlePartTabData(dataFromPartTab) {
            var self = this;
            self.partTabData = dataFromPartTab;
            this.$refs.otherChargeTab.emitDataToParent();
        },

        handleOtherChargesTabData(dataFromOtherChargesTab) {
            var self = this;
            self.otherChargesTabData = dataFromOtherChargesTab;
            this.$refs.attachmentTab.emitDataToParent();
        },

        handleAttachmentTabData(dataFromAttachmentTab, flag) {
            var self = this;
            self.attachmentTabData = dataFromAttachmentTab;
            this.$refs.summaryTab.emitDataToParent();
        },
        handlesummaryTabData(dataFromsummaryTab) {
            this.summaryTabData = dataFromsummaryTab;
            this.prepareWarrantyClaimData();
        },
        handlePartAttachment(partAttachment) {
            this.partAttachment = partAttachment;
        },
        handlePositionCodeData(positionCode) {
            this.$refs.claimTab.getPositionCodeFromParent(positionCode.position_code);
        },
        handleFormFieldsChanges() {
            this.formFieldChanged = false;

            // Define an array of functions with their respective tab references
            const tabs = [
                { tab: this.$refs.claimTab, method: 'populateInitialClaimData' },
                { tab: this.$refs.failureTab, method: 'populateInitialFailureData' },
                { tab: this.$refs.laborTab, method: 'populateInitialLaborData' },
                { tab: this.$refs.partTab, method: 'populateInitialPartData' },
                { tab: this.$refs.otherChargeTab, method: 'populateInitialOtherChargesData' },
                { tab: this.$refs.attachmentTab, method: 'populateInitialAttachmentData' },
                { tab: this.$refs.summaryTab, method: 'populateInitialSummaryData' }
            ];

            // Iterate through the tabs array
            for (let { tab, method } of tabs) {
                // Call the respective method on each tab
                this.formFieldChanged = tab[method](false);
                if (this.formFieldChanged) {
                    // Stop if true
                    return this.formFieldChanged;
                }
            }

            // Returns false if none are true
            return this.formFieldChanged;
        },
        validateTabDataForSave() {
            const self = this;
            self.handleClaimStatus(self.changedClaimStatus);
            let success = true;
            if(self.setClaimStatus !== 'Returned for Corrections'){
              const tabValidations = {
                claimTab: { method: 'validateClaimFields', params: [self.rmaRequired, self.cmIssued] },
                failureTab: { method: 'validateFailureFields', params: [] },
                laborTab: { method: 'validateAllRowsForSend', params: [] },
                partTab: { method: 'validateAllRowsForSend', params: [] },
                otherChargeTab: { method: 'validateAllRowsForSend', params: [] },
                attachmentTab: { method: 'validateAllRowsForSend', params: [] },
                summaryTab: { method: 'validateSummaryFields', params: [] }
              };


              // Check each tab's validation result
              for (const [tab, { method, params }] of Object.entries(tabValidations)) {
                const tabComponent = self.$refs[tab];
                if (tabComponent && typeof tabComponent[method] === 'function') {
                  const isValid = tabComponent[method](...params);
                  success = success && isValid;
                }
              }
            }

            // Scroll to error if validation fails
            if (!success) {
                self.reAddDollarSignToAmounts();
                setTimeout(() => {
                    self.scrollToError();
                }, 500);
            }

            return success;
        },
        prepareWarrantyClaimData() {
            // for the dealer
            // no need to call the validate function if the claim status is draft
            //and the user is attempting to save/update the form and not submit it
            // also when the user is in create page and clicks on save button and not the submit button

            // for the admin/rizon rep
            // if the claim status is open or in process, and the set claim status is "In process"
            // and the save and continue button has been clicked, the validation can be skipped.

        if (
          (
            !this.canViewAllFields
            &&
            (
              (this.setClaimStatus == "" && this.claimStatus == "Draft")
              ||
              ((!this.isEditPage) && this.setClaimStatus == "")
            )
          )
          ||
          (
            this.canViewAllFields
            &&
            (this.claimStatus == "Open" || this.claimStatus == "In Process")
            &&
            this.setClaimStatus == "In Process"
          )
        ) {
          var success = true;
        } else {
          var success = this.validateTabDataForSave();
        }
        if (
          this.setClaimStatus === 'Rejection/Denied'
          ||
          this.setClaimStatus === 'Returned for Corrections'
        ) {
          this.setUpWarrantyClaimData();
        } else {
          if (this.useSubmitMessage) {
            var message = 'Are you sure you want to submit this claim?';
          } else {
            if(this.canViewAllFields || this.statusOpenBtnEnable){
              var message = 'Are you sure you want to save this claim?';
            } else if (this.setClaimStatus === 'Corrections Made/Dealer Response') {
              var message = 'Are you sure you want to submit the corrections made?';
            } else {
              var message = 'Are you sure you want to save this claim? Saving does not submit to Rizon for processing!';
            }
          }

          if (success) {
            this.$swal({
              title: message,
              type: 'warning',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              showCancelButton: true,
            }).then((result) => {
              if (result.value) {
                this.setUpWarrantyClaimData();
              } else {
                if (this.useSubmitMessage) {
                  this.useSubmitMessage = false;
                }
                this.clearButtonFocus();
                this.reAddDollarSignToAmounts();
                this.setClaimStatus = "";
                this.$parent.loading = false;
              }
            });
          } else {
            this.$parent.loading = false;
            this.setClaimStatus = '';
          }
        }

      },
      setUpWarrantyClaimData() {
        if (this.additionalComment != null) {
          this.claimTabData.additionalComment = this.additionalComment;
        }
        this.warrantyClaimData = {
          claimTabData: this.claimTabData,
          failureTabData: this.failureTabData,
          laborTabData: this.laborTabData,
          partTabData: this.partTabData,
          otherChargesTabData: this.otherChargesTabData,
          attachmentTabData: this.attachmentTabData,
          summaryTabData: this.summaryTabData,
          warrantyClaimId: this.claimId,
          setClaimStatus: this.setClaimStatus,
        };
        // function call /
        this.saveWarrantyClaim();
      },
        saveWarrantyClaim() {
            var self = this;
            let formData = new FormData();
            formData.append('partAttachment', self.partAttachment);
            formData.append("warrantyClaimData", JSON.stringify(self.warrantyClaimData));
            formData = self.setAttachments(
                formData,
                self.warrantyClaimData.attachmentTabData.attachmentRows,
                'attachment'
            );
            formData = self.setAttachments(
                formData,
                self.warrantyClaimData.otherChargesTabData.rows,
                'otherChargesAttachment'
            );
            $.ajax({
                url: process.env.ROOT_API + "/warranty-claim/save",
                type: "POST",
                data: formData,
                headers: {
                    "Accept": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    "Access-Control-Allow-Headers":
                        "Origin, Content-Type, Authorization,X-Requested-With",
                    "Cache-Control": "no-cache"
                },
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    if (self.claimCreateFlag == 'Save and Continue') {
                        self.$parent.handleButtonClick();
                        self.$router.push({ name: 'WarrantyClaimEdit', params: { id: data.content } });
                    } else if (self.claimCreateFlag == 'Update and Continue') {
                        self.reAddDollarSignToAmounts();
                        self.scrollToTop();
                        self.clearButtonFocus();
                    } else {
                        self.$parent.handleButtonClick();
                        self.$router.push({ name: 'WarrantyClaimList' });
                    }
                    self.$parent.loading = false;
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'warranty-claim-create')
                }
            })
        },
        handlePartNumberData(partNumber) {
            this.$refs.failureTab.getRootCausePartFromParent(partNumber);
        },
        emitDataToParent(flag) {
            var self = this;
            const dataToSend = {
                claimTabData: self.claimTabData,
                failureTabData: self.failureTabData,
                partTabData: self.partTabData,
                laborTabData: self.laborTabData,
                otherChargesTabData: self.otherChargesTabData,
                locationTabData: self.locationTabData,
                paymentTabData: self.paymentTabData,
                attachmentTabData: self.attachmentTabData,
                warrantyClaimId: self.claimId,
            };
            self.$emit("send-data-to-parent", dataToSend, flag);
        },
        scrollTo(refName, fixedHeaderHeight) {
            const element = this.$refs[refName];
            fixedHeaderHeight = fixedHeaderHeight + 85;
            if (element) {
                const elementPosition = element.$el.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - fixedHeaderHeight;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        },
        emitClaimNumbertoParent(dataToSend) {
            this.$emit("send-claim-number-to-parent", dataToSend);
        },
        emitVINToParent(dataToSend) {
            this.$emit("send-vin-to-parent", dataToSend);
        },
        getSectionData(flag = '') {
            this.$parent.loading = true;
            if (flag == "rizon-save-and-close") {
                this.setClaimStatus = "In Process";
            } else {
                this.claimCreateFlag = flag;
            }
            this.$refs.claimTab.emitDataToParent();
        },
        setAttachments(formData, attachments, $text) {
            for (let i = 0; i < attachments.length; i++) {
                formData.append($text + '-' + i, attachments[i].file);
            }
            return formData;
        },
        loadClaimData() {
            var self = this;

            self.$parent.loading = true;
            if (self.claimId != null) {
                $.ajax({
                    url: process.env.ROOT_API + "/warranty-claim/view/" + self.claimId,
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("tkn"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        self.$parent.loading = false;
                        self.claimHeaderId = data.content.ev_claim_header_id;
                        self.claimStatus = data.content.claim_status;
                        self.$emit("send-claim-status-to-parent", self.claimStatus);

                        if (self.canViewAllFields) {
                            self.checkClaimStatus();
                        }

                        self.populateClaimHeaderData(
                            data.content.ev_claim_header,
                            data.content.claim_status,
                            data.content.claim_number,
                            data.content.created_by
                        );
                        self.populateRepairDetailData(data.content.ev_repair_detail);
                        self.populateLaborData(data.content.ev_labor);
                        self.populatePartData(data.content.ev_part);
                        self.populateOtherChargeData(data.content.ev_other_charge);
                        self.populateAttachmentData(data.content.ev_attachment);
                        self.populateSummaryData(data.content.ev_summary);
                        if (self.setClaimStatus == 'In Process') {
                            self.startProcessButtonClicked(true);
                        }

                        // Check if all required credit memo fields have values
                        if (
                            data.content.ev_claim_header.credit_memo_issued_by &&
                            data.content.ev_claim_header.credit_memo_pdf_path &&
                            data.content.ev_claim_header.credit_memo_date &&
                            data.content.ev_claim_header.credit_memo_number
                        ) {
                            // If all fields have values, hide the credit memo button
                            self.hideCreditMemoButton = true;
                        } else {
                            // If any field is missing, show the credit memo button
                            self.hideCreditMemoButton = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.$parent.loading = false;
                        self.generateStatusCodeMessage(jqXHR, false, 'warranty-claim-create')
                        self.showButtons = false;
                    }
                });
            }
        },
        checkClaimStatus() {
            if (
                this.claimStatus == "Deleted"
                ||
                this.claimStatus == "Draft"
                ||
                this.claimStatus == "Open"
                ||
                this.claimStatus == ""
            ) {
                this.disableFields = false;
            } else {
                this.disableFields = true;
            }
        },
        populateClaimHeaderData(claimHeaderData, claimStatus, claimNumber, createdBy) {
            this.$refs.claimTab.getDataFromParent(claimHeaderData, claimStatus, claimNumber, createdBy, this.claimId);
        },
        populateRepairDetailData(repairDetailData) {
            this.$refs.failureTab.getDataFromParent(repairDetailData);
        },
        populateLaborData(laborData) {
            this.$refs.laborTab.getDataFromParent(laborData);
        },
        populatePartData(partData) {
            this.$refs.partTab.getDataFromParent(partData);
        },
        populateOtherChargeData(otherChargeData) {
            this.$refs.otherChargeTab.getDataFromParent(otherChargeData);
        },
        populateAttachmentData(attachmentData) {
            this.$refs.attachmentTab.getDataFromParent(attachmentData);
        },
        populateSummaryData(summaryData) {
            this.$refs.summaryTab.getDataFromParent(summaryData);
        },
        handleLaborCalculationData(calculationData) {
            this.$refs.summaryTab.getLaborCalculationDataFromParent(calculationData);
        },
        handlePartCalculationData(calculationData) {
            this.$refs.summaryTab.getPartCalculationDataFromParent(calculationData);
        },
        handleOtherChargesCalculationData(calculationData) {
            this.$refs.summaryTab.getOtherChargesCalculationDataFromParent(calculationData);
        },
        clearAllContentsFields() {
            var self = this;
            self.$refs.claimTab.clearAllFields();
            self.$refs.failureTab.clearAllFields();
            self.$refs.laborTab.clearAllFields(self.rePopulate);
            self.$refs.partTab.clearAllFields(self.rePopulate);
            self.$refs.otherChargeTab.clearAllFields();
            self.$refs.attachmentTab.clearAllFields();
            self.$refs.summaryTab.clearAllFields();
        },
        validateFieldsForDeny() {
            const checkRejectionReason = (items, statusKey = 'approval_status') => {
                let isValid = true;
                items.forEach(item => {
                    item.rejectionReasonErrorMsg = '';
                    const status = item[statusKey];
                    if (status === 'Rejected' && !item.rejectionReason) {
                        item.rejectionReasonErrorMsg = 'Rejection Reason Required';
                        isValid = false;
                    }
                });
                return isValid;
            };

            let success = true;

            if (this.$refs.partTab.rows) {
                success = checkRejectionReason(this.$refs.partTab.rows) && success;
            }

            if (this.$refs.partTab.oem_rows) {
                success = checkRejectionReason(this.$refs.partTab.oem_rows, 'approvalStatus') && success;
            }

            return success;
        },
        deleteClaimModal(flag) {
            this.setClaimStatus = flag;
            var success = true;

            if (this.setClaimStatus == "Deleted") {
                var messageTitle = "Are you sure you want to delete this claim?";
                this.commentModalHeader = "Reason For Deleting Claim.";
            } else if (this.setClaimStatus == "Rejection/Denied") {
                var messageTitle = "Are you sure you want to deny this claim?";
                this.commentModalHeader = "Reason For Denying Claim.";
                success = this.validateFieldsForDeny();
            } else if (this.setClaimStatus == "Returned for Corrections") {
                var messageTitle = "Are you sure you want to return this claim for corrections?";
                this.commentModalHeader = "Reason For Returning this claim for corrections.";
            }

            if(success){
                this.$swal({
                    title: messageTitle,
                    type: 'warning',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                }).then((result) => {
                    if (result.value) {
                        this.deleteComment = '';
                        this.deleteCommentErrorMsg = '';
                        this.deleteCommentCharsCount = 0;
                        $('#addDeleteCommentModal').modal('show');
                    } else {
                        this.setClaimStatus = '';
                    }
                });
            } else {
                setTimeout(() => {
                    this.scrollToError();
                }, 500);
            }
        },
        addDeleteComment() {
            var self = this;
            self.deleteCommentErrorMsg = '';
            var fields = [];

            var success = true;
            if (self.deleteComment == null || self.deleteComment == '') {
                self.deleteCommentErrorMsg = "Reason Required";
                success = false;
            }

            if (success) {
                self.$parent.loading = true;
                fields.push({
                    'id': '',
                    'comment': self.deleteComment,
                    'comment_by': self.userObj.id,
                    'comment_date': moment().tz('PST8PDT').format('hh:mm A (MM/DD/YYYY)'),
                });

                if (self.setClaimStatus == "Returned for Corrections") {
                    self.additionalComment = fields;
                    self.$parent.loading = false;
                    $('#addDeleteCommentModal').modal('hide');
                    self.getSectionData();
                } else {
                    $.ajax({
                        url: process.env.ROOT_API + "/warranty-claim/save-comment",
                        type: 'POST',
                        data: {
                            claimId: self.claimId,
                            claimHeaderId: self.claimHeaderId,
                            comments: fields,
                            flag: self.setClaimStatus,
                        },
                        headers: self.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.$parent.loading = false;
                            if (data.status == 'success') {
                                self.$parent.handleButtonClick();
                                self.deleteComment = '';
                                self.deleteCommentErrorMsg = '';
                                self.deleteCommentCharsCount = 0;
                                $('#addDeleteCommentModal').modal('hide');
                                self.getSectionData();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.$parent.loading = false;
                            self.generateStatusCodeMessage(jqXHR, false, 'warranty-claim-create')
                        }
                    });
                }
            }
        },
        generatePDF() {
            var self = this;

            self.$parent.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/warranty-claim/generate-pdf/" + self.claimId,
                type: 'GET',
                headers: self.ajxHeaders,
                dataType: "json",
                data: { workHistory: false },
                success: function (data) {
                    self.$parent.loading = false;
                    if (data.code == 200) {
                        let doc = document.createElement('a');
                        doc.href = data.content;
                        doc.download = data.content;
                        doc.target = '_blank';
                        document.body.appendChild(doc);
                        doc.click();
                        document.body.removeChild(doc);
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'warranty-claim-create')
                }
            });
        },
        scrollToError() {
            // Define the height of the fixed header
            const headerHeight = document.querySelector('.warranty-create-header').offsetHeight || 0;

            // Iterate over all fields with error messages
            const errorFields = document.querySelectorAll('.field-error');
            for (const errorField of errorFields) {
                // Check if errorField exists and contains text
                if (errorField.textContent.trim().length > 0) {
                    const parent = errorField.parentElement;
                    const inputField = parent.querySelector('input, textarea, select');

                    if (inputField) {
                        // Check if the field is disabled
                        if (inputField.disabled) {
                            // Calculate the position of the field relative to the document, subtract the header height
                            const fieldTop = inputField.getBoundingClientRect().top + window.scrollY;
                            const scrollPosition = fieldTop - headerHeight - 100; // Add a small offset (10px)

                            // Scroll to the calculated position smoothly
                            window.scrollTo({
                                top: scrollPosition,
                                behavior: 'smooth',
                            });
                        } else {
                            // Scroll to the input field normally
                            inputField.scrollIntoView({ behavior: 'smooth', block: 'start' });

                            // Focus the field if it's not disabled
                            setTimeout(() => {
                                inputField.focus();
                            }, 50);
                        }

                        // Exit the loop after scrolling to the first error
                        return;
                    }
                }
            }
        },
        submitWarrantyClaim() {
            this.setClaimStatus = "Open";
            this.useSubmitMessage = true;
            this.getSectionData();
        },
        correctionsMadeForWarrantyClaim() {
            this.setClaimStatus = 'Corrections Made/Dealer Response';
            this.getSectionData();
        },
        acceptWarrantyClaim() {
            this.setClaimStatus = "Accepted";
            this.getSectionData();
        },
        startProcessWarrantyClaim() {
            this.setClaimStatus = "In Process";
            this.changeClaimStatus();
        },
        createRMAButton() {
            this.rmaRequired = true;
            this.cmIssued = false;
            var success = this.$refs.claimTab.validateClaimFields(this.rmaRequired);
            if (success) {
                this.$refs.claimTab.emitRmaToParent();
            } else {
                this.setClaimStatus = "";
                setTimeout(() => {
                    this.scrollToError();
                }, 500);
            }
        },
        handleRma(value) {
            this.rma = value.rma;
            this.setClaimStatus = "Waiting on Parts";
            this.changeClaimStatus();
        },
        handleCMIssued(value) {
            this.creditMemoNumber = value.credit_memo_number;
            this.creditMemoDate = value.credit_memo_date;
            this.setClaimStatus = "CM Issued";
            this.changeClaimStatus();
        },
        submitForPaymentButton() {
            this.setClaimStatus = "Payment Pending";
            this.changeClaimStatus();
        },
        creditMemoIssuedButton() {
            this.$router.push({
                name: 'CreateCreditMemo',
                params: { id: this.claimId }
            });
        },
        handleRepairDate(date) {
            this.$refs.failureTab.getRepairDate(date);
        },
        showSwalPopup(flag) {
            let text = '';
            if (flag == 'cancel') {
                text = this.cancelPopUpMsg;
            } else if (flag == 'clear') {
                text = this.clearContentPopUpMsg;
            }
            // Clear focus from any focused buttons
            this.clearButtonFocus();

            this.$swal({
                title: text,
                type: 'warning',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCancelButton: true,
            }).then((result) => {
                if (result.value) {
                    this.setClaimStatus = '';
                    this.loading = true;
                    if (flag == 'cancel') {
                        if(this.canViewAllFields){
                            this.rePopulate = true;
                            this.clearAllContentsFields();
                            this.loadClaimData();
                        } else {
                            this.$parent.handleButtonClick();
                            this.redirectBackUrl();
                        }
                    } else if (flag == 'clear') {
                        this.clearAllContentsFields();
                    }
                    this.scrollToTop();
                }
                this.loading = false;
                // Clear focus from any focused buttons again, if needed
                this.clearButtonFocus();
                this.rePopulate = false;
            });
        },
        redirectBackUrl() {
            var url = "/warranty-claim/queue";
            this.redirectPageUrl(url);
        },
        clearButtonFocus() {
            setTimeout(() => {
                const focusedButtons = document.querySelectorAll('button:focus');
                focusedButtons.forEach(button => button.blur());
            }, 300);
        },
        scrollToTop() {
            const fixedHeaderHeight = document.querySelector('.page-name').offsetHeight || 0;
            setTimeout(() => {
                this.scrollTo('claimTab', fixedHeaderHeight);
            }, 500);
        },
        changeClaimStatus() {
            var self = this;
            self.$parent.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/change-claim-status",
                type: 'POST',
                data: {
                    claimId: self.claimId,
                    setClaimStatus: self.setClaimStatus,
                    rma: self.rma,
                    creditMemoDate: self.creditMemoDate,
                    creditMemoNumber: self.creditMemoNumber,
                },
                headers: self.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    if (self.setClaimStatus == 'In Process') {
                        self.rePopulate = true;
                        self.clearAllContentsFields();
                        self.loadClaimData();
                        self.scrollToTop();
                        self.clearButtonFocus();
                        if (self.canViewAllFields) {
                            self.disableSaveButtons = false;
                        }
                    } else {
                        self.$parent.handleButtonClick();
                        self.$router.push({ name: 'WarrantyClaimList' });
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.rma = "";
                    self.generateStatusCodeMessage(jqXHR, false, 'warranty-claim-create');
                }
            });
        },
        startProcessButtonClicked(flag) {
            this.$refs.laborTab.startProcessButtonClicked(flag);
            this.$refs.partTab.calculatePartsAmount(flag);
            this.$refs.partTab.calculateNonOemPartsAmount(flag);
            this.$refs.otherChargeTab.calculateSubletChargesAmount(flag);
            this.$refs.otherChargeTab.calculateTravelChargesAmount(flag);
        },
        handleClaimStatus(status) {
            this.changedClaimStatus = status;
            this.rmaRequired = false;
            this.cmIssued = false;
            if (this.changedClaimStatus == 'Waiting on Parts') {
                this.rmaRequired = true;
            } else if (this.changedClaimStatus == 'CM Issued') {
                this.cmIssued = true;
            }
        },
        reAddDollarSignToAmounts() {
            this.$refs.laborTab.validationFail();
            this.$refs.partTab.validationFail();
            this.$refs.otherChargeTab.validationFail();
        },
        handleLaborTravelRate(rates) {
            this.$refs.laborTab.populateLaborRate(rates.laborRate);
            this.$refs.otherChargeTab.populateTravelRate(rates.timeTravelRate, rates.distanceTravelRate);
        }
    }

}
</script>
<style scoped>
.button-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    /* Adjust the gap as needed */
    padding: 20px;
    /* Add padding to the container */
}

.btn {
    margin-right: 0 !important;
    /* Remove individual margins */
}

@media (max-width: 768px) {
    .button-container {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .button-container {
        grid-template-columns: 1fr;
    }
}

.btn-secondary:disabled:hover,
.btn-secondary:disabled:active,
.btn-secondary:disabled:focus {
    background-color: #6c757d !important;
    border-color: #6c757d !important;
    color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/WarrantyClaimFormCreate.vue